// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__2wGju","paymentContainer":"PaymentPage_paymentContainer__3Lby2"};